/* tslint:disable */
/* eslint-disable */
/**
 * API
 * API
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */




export const ActivityTypeDto = {
    ProcessCreated: 'PROCESS_CREATED',
    ProcessUpdated: 'PROCESS_UPDATED',
    ProcessStatusChanged: 'PROCESS_STATUS_CHANGED',
    ProcessOwnerChanged: 'PROCESS_OWNER_CHANGED',
    ProcessCustomerChanged: 'PROCESS_CUSTOMER_CHANGED',
    ProcessContactsChanged: 'PROCESS_CONTACTS_CHANGED',
    NoteAdded: 'NOTE_ADDED',
    NoteDeleted: 'NOTE_DELETED',
    EmailSent: 'EMAIL_SENT',
    OfferCreated: 'OFFER_CREATED',
    OfferCopiedAsVersion: 'OFFER_COPIED_AS_VERSION',
    OfferUpdated: 'OFFER_UPDATED',
    OfferStatusChanged: 'OFFER_STATUS_CHANGED',
    OfferSent: 'OFFER_SENT',
    OfferScheduleChanged: 'OFFER_SCHEDULE_CHANGED',
    OfferGroupAdded: 'OFFER_GROUP_ADDED',
    OfferGroupUpdated: 'OFFER_GROUP_UPDATED',
    OfferGroupDeleted: 'OFFER_GROUP_DELETED',
    OfferGroupCommentChanged: 'OFFER_GROUP_COMMENT_CHANGED',
    OfferGroupSelectionChanged: 'OFFER_GROUP_SELECTION_CHANGED',
    OfferGroupInsertedFromLibrary: 'OFFER_GROUP_INSERTED_FROM_LIBRARY',
    OfferSubgroupAdded: 'OFFER_SUBGROUP_ADDED',
    OfferSubgroupUpdated: 'OFFER_SUBGROUP_UPDATED',
    OfferSubgroupDeleted: 'OFFER_SUBGROUP_DELETED',
    OfferSubgroupCommentChanged: 'OFFER_SUBGROUP_COMMENT_CHANGED',
    OfferSubgroupSelectionChanged: 'OFFER_SUBGROUP_SELECTION_CHANGED',
    OfferSubgroupPortionsDistributed: 'OFFER_SUBGROUP_PORTIONS_DISTRIBUTED',
    OfferDishesChanged: 'OFFER_DISHES_CHANGED',
    OfferDishUpdated: 'OFFER_DISH_UPDATED',
    OfferDishRemoved: 'OFFER_DISH_REMOVED',
    OfferStructureReordered: 'OFFER_STRUCTURE_REORDERED',
    OfferElementAdded: 'OFFER_ELEMENT_ADDED',
    OfferElementUpdated: 'OFFER_ELEMENT_UPDATED',
    OfferElementDeleted: 'OFFER_ELEMENT_DELETED',
    OfferElementItemAdded: 'OFFER_ELEMENT_ITEM_ADDED',
    OfferElementItemUpdated: 'OFFER_ELEMENT_ITEM_UPDATED',
    OfferElementItemDeleted: 'OFFER_ELEMENT_ITEM_DELETED',
    OfferElementCommentChanged: 'OFFER_ELEMENT_COMMENT_CHANGED',
    OfferElementSkipped: 'OFFER_ELEMENT_SKIPPED',
    OfferElementRestored: 'OFFER_ELEMENT_RESTORED',
    OfferPriceOverrideRequested: 'OFFER_PRICE_OVERRIDE_REQUESTED',
    OfferPriceOverrideAccepted: 'OFFER_PRICE_OVERRIDE_ACCEPTED',
    MultiOfferCreated: 'MULTI_OFFER_CREATED',
    MultiOfferUpdated: 'MULTI_OFFER_UPDATED',
    MultiOfferStatusChanged: 'MULTI_OFFER_STATUS_CHANGED',
} as const;

export type ActivityTypeDto = typeof ActivityTypeDto[keyof typeof ActivityTypeDto];



